import React, { useState } from 'react';
import ContactModal from './ContactModal';

const FinalCTA = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <section className="py-8 bg-[#006241] text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold mb-6">
          Light Up Your Holidays with Prime Christmas Lighting!
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Serving Barrie, Collingwood, Orillia & surrounding areas with professional 
          Christmas light installation services.
        </p>
        
        <div className="flex flex-col md:flex-row gap-6 justify-center items-center mb-8">
          <a href="tel:7057950759" className="flex items-center text-xl hover:text-yellow-300 transition-colors">
            <span className="mr-2">📞</span>
            (705) 795-0759
          </a>

           <a href="https://mail.google.com/mail/?view=cm&fs=1&to=primeholidaylights@gmail.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 mr-5 text-white-900 font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v.01L12 13 2 4.01V4zm0 2.236v13.764A2 2 0 0 0 4 22h16a2 2 0 0 0 2-2V6.236l-9.197 7.424a1 1 0 0 1-1.606 0L2 6.236z"/>
            </svg>
            primeholidaylights@gmail.com
          </a>
        </div>
        
        <button 
          onClick={() => setShowForm(true)}
          className="bg-white text-red-600 px-8 py-4 rounded-lg text-xl font-bold hover:bg-yellow-100 transition-all duration-300 transform hover:scale-105 shadow-lg"
        >
          Request Your Free Quote
        </button>
        
        <ContactModal isOpen={showForm} onClose={() => setShowForm(false)} />
      </div>
    </section>
  );
};

export default FinalCTA;